import React from "react";
import { humanize } from "./humanize";

const ReglesCalculSidebar = ({ categories, activeId, onItemClick }) => {
  return (
    <nav className="regles-calcul__sidebar" aria-label="Navigation des règles">
      {categories.map(({ key: categorieKey, champs }) => {
        if (champs.length === 0) return null;
        return (
          <div key={categorieKey} className="regles-calcul__sidebar-group">
            <div className="regles-calcul__sidebar-group-title">
              {humanize(categorieKey)}
            </div>
            <ul className="regles-calcul__sidebar-list">
              {champs.map((champKey) => {
                const id = `regle-${categorieKey}-${champKey}`;
                const isActive = id === activeId;
                return (
                  <li key={champKey}>
                    <button
                      type="button"
                      className={
                        "regles-calcul__sidebar-item" +
                        (isActive ? " regles-calcul__sidebar-item--active" : "")
                      }
                      onClick={() => onItemClick(id)}
                    >
                      {humanize(champKey)}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </nav>
  );
};

export default ReglesCalculSidebar;
